angular.module('app.api').factory('PositionApi', [
  'api',
  function PositionApi(api) {
    const positionApi = {
      getPositionListing: payload => {
        return api.get('listings/position', {params: payload})
      },
      getPositionById: positionId => {
        return api.get(`positions/${positionId}`)
      },
      getAllPositions: async payload => {
        console.debug('getAllPositions', payload)
        const result = await api.get(`positions`, payload)
        console.debug('getAllPositions result', result)
        return result
      },
      getPositionsForClone: async payload => {
        console.debug('getPositionsForClone', payload)
        const result = await api.get(`positions/clone`, payload)
        console.debug('getPositionsForClone result', result)
        return result
      },
      createPosition: payload => {
        return api.post(`positions`, payload)
      },
      updatePositionById: (positionId, payload) => {
        return api.put(`positions/${positionId}`, payload)
      },
      updateMultiplePositions: payload => {
        return api.put(`positions`, payload)
      },
      deletePositionById: (positionId, payload) => {
        return api.delete(`positions/${positionId}`, payload)
      },
      createClonePositions: payload => {
        return api.post(`positions/clone`, payload)
      },
      addPositionQuestion: (positionId, payload) => {
        return api.post(`positions/${positionId}/questions`, payload)
      },
    }
    return positionApi
  },
])



// WEBPACK FOOTER //
// ./scripts/admin-panel/position-listing/position-listing.api.js